import { render, staticRenderFns } from "./RollingNotice.vue?vue&type=template&id=0285ad8c&scoped=true"
import script from "./RollingNotice.vue?vue&type=script&lang=js"
export * from "./RollingNotice.vue?vue&type=script&lang=js"
import style0 from "./RollingNotice.vue?vue&type=style&index=0&id=0285ad8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0285ad8c",
  null
  
)

export default component.exports